export const theme = {
  colors: {
    // Gen-Z Wellness + Mint Palette
    primary: {
      50: '#f0fdf9',
      100: '#ccfbef',
      200: '#99f6e0',
      300: '#5fe9d0',
      400: '#2dd4bf',
      500: '#14b8a6',
      600: '#0d9488',
      700: '#0f766e',
      800: '#115e59',
      900: '#134e4a',
    },
    mint: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
    },
    glow: {
      mint: '#E8F5EF',
      sage: '#D4E9E2',
      aqua: '#B8DFD8',
      teal: '#8DD0C7',
      forest: '#5BB5A8',
    },
    neutral: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#e5e5e5',
      300: '#d4d4d4',
      400: '#a3a3a3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      900: '#171717',
    },
    accent: {
      coral: '#FF9B9B',
      peach: '#FFD6A5',
      lavender: '#CABFFF',
      sky: '#A0C4FF',
    },
    background: {
      primary: '#ffffff',
      secondary: '#E8F5EF',
      tertiary: '#f0fdf4',
      warm: '#fffbf5',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#4a5568',
      tertiary: '#718096',
      mint: '#0f766e',
    },
    border: {
      light: '#e8f5ef',
      medium: '#d4e9e2',
      dark: '#8dd0c7',
    },
    status: {
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6',
    }
  },
  typography: {
    fontFamily: {
      primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      secondary: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
    },
    fontWeight: {
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800',
    },
    lineHeight: {
      tight: '1.25',
      normal: '1.5',
      relaxed: '1.75',
    }
  },
  spacing: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
  },
  borderRadius: {
    none: '0',
    sm: '0.25rem',
    base: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    full: '9999px',
  },
  shadows: {
    sm: '0 2px 4px 0 rgba(20, 184, 166, 0.08)',
    base: '0 4px 8px 0 rgba(20, 184, 166, 0.12)',
    md: '0 8px 16px 0 rgba(20, 184, 166, 0.15)',
    lg: '0 16px 32px 0 rgba(20, 184, 166, 0.18)',
    xl: '0 24px 48px 0 rgba(20, 184, 166, 0.20)',
    glow: '0 0 20px rgba(20, 184, 166, 0.3)',
    glowStrong: '0 0 30px rgba(20, 184, 166, 0.5)',
  },
  animations: {
    glowPulse: 'glowPulse 2s ease-in-out infinite',
    fadeIn: 'fadeIn 0.3s ease-in',
    slideUp: 'slideUp 0.4s ease-out',
    bounce: 'bounce 0.6s ease-in-out',
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  }
};

export type Theme = typeof theme;
